module.exports = __webpack_public_path__ + "img/img_bg5_meeting.2813f833.png";